import React from "react";
import Tree from "../../components/HierarchyTree";
import { useParams, useHistory } from "react-router-dom";
import { getTenantTree, getTenant } from "../../api/tenants";
import { useAuth0 } from "../../auth/react-auth0-wrapper";

const TenantTree = ({ activeTenant }) => {
  const [loading, setLoading] = React.useState(true);
  const { push } = useHistory();
  const {
    changeActiveTenant
  } = useAuth0();
  const [data, setData] = React.useState([]);
  const id = activeTenant ? activeTenant._id : useParams().id


  React.useEffect(() => {
    loadData(id);
  }, [id]);

  const loadData = async id => {
    try {
      setLoading(true);
      const result = await getTenantTree(id);
      setData(result);
      return result;
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const onExplore = async (id) => {
    try {
      setLoading(true);
      const tenant = await getTenant(id);
      changeActiveTenant(tenant);
      push("/tenant/structure")
    } finally {
      setLoading(false);
    }
  }

  return (
    <Tree
      loading={loading}
      data={data}
      onExplore={onExplore}
    />
  );
};

export default TenantTree;
